const captionElements = document.querySelectorAll('.jsCaption');

for (const captionElement of captionElements) {
  // Get the picture element
  const pictureElement = captionElement.querySelector('picture');

  // Get the alt text
  const altText = pictureElement.querySelector('img').alt;

  // Create a paragraph element
  const paragraphElement = document.createElement('p');

  // Add the alt text to the paragraph element
  paragraphElement.textContent = altText;

  // Insert the paragraph element after the picture element
  captionElement.appendChild(paragraphElement);
}